export default __webpack_public_path__ + "static/media/image-chair-algo-q-7-w@2x.22a2600d.png";